import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import JobsSummary from './Widgets/JobsSummary';
import Notifications from './Notifications';
import Onboarding from './Widgets/Onboarding';
import Stats from './Widgets/Stats';
import { Sections } from '../../Components/Containers/Section';
import { useSession } from '../../Components/Session';
import BusinessSwitcher from './BusinessSwitcher';
import Threads from './Widgets/Threads';
import MobileNotifications from './Widgets/MobileNotifications';
import { Roles } from '../../Data/Users';
import ScheduleOverview from './Widgets/ScheduleOverview';
import NoItems from '../../Components/EmptyStates/NoItems';
import { useRedirect } from '../../Services/helpers';
import UpdatePrompt from '../../Components/UpdatePrompt';
import HomeRedesign from './Redesign';
import TriggersWidget from './Widgets/Triggers';
// import RedesignPrompt from './RedesignPrompt';

const Home = () => {
    const {isRoleSufficient, showRedesign, showDarkMode, isAdmin} = useSession();
    const {go, Redirect} = useRedirect();

    if (showRedesign) {
        return <HomeRedesign />;
    }

    return <>
        <TopBar
            left={<BusinessSwitcher />}
            title={
                <img src={showDarkMode ? "/logo-name-horizontal-36-dark.png" : "/logo-name-horizontal-36.png"}
                    className="h-[36px] w-[175px] mt-1 mx-auto"
                    alt="getSoapy"
                    width="175"
                    height="36"
                    onClick={() => window.location.reload(true)}
                />
            }
            right={<Notifications />}
        />

        <Page>
            <Sections>
                {/* <RedesignPrompt /> */}
                <UpdatePrompt />
                <MobileNotifications />

                {isRoleSufficient(Roles.Manager) && <>
                    <Onboarding />
                    {isAdmin() && <TriggersWidget />}
                    <ScheduleOverview />
                    <Stats />
                    <JobsSummary />
                    <Threads />
                </>}
                {!isRoleSufficient(Roles.Manager) && <>
                    <NoItems
                        title="Limited access"
                        message="Your current role has limited access, tap to see the work view."
                        icon="Lock"
                        onClick={() => go('/work')}
                    />
                    <Redirect />
                </>}
            </Sections>

        </Page>
    </>
}

export default Home;
